import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';

import App from './App';

import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import 'react-datepicker/dist/react-datepicker.css';

import 'assets/bootstrap/scss/bootstrap.scss';
import 'assets/fonts/fontawesome-free-5.5.0-web/css/all.min.css';
import 'assets/fonts/nunito-sans/stylesheet.css';

import store from './store';

import history from './history';

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <App />
    </Router>
  </Provider>,
  document.getElementById('root'),
);
